import { MessageCircle } from "lucide-react";

// Round WhatsApp mark
export default function WhatsAppFab() {
  return (
    <a
      href="https://wa.me/8619878000805"
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-fab"
      aria-label="Contactez-nous sur WhatsApp"
      className="fixed bottom-6 right-24 z-40 w-14 h-14 rounded-full bg-[#25D366] text-white shadow-[0_10px_30px_rgba(37,211,102,0.45)] hover:scale-105 transition-transform flex items-center justify-center"
    >
      <MessageCircle size={22} fill="white" />
    </a>
  );
}
